export default __webpack_public_path__ + "static/media/mergeAccountsIconBlack.320975d7.svg";